import React, { useState, useEffect } from "react";
import "./Withdraw.css";
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFileUpload } from "react-icons/fa";
import Header from "../header/Header";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import Appconfig from "../../config/config";
import Helper from "../../helper";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Input, Table, Image, Button, Switch } from "antd";
import { getPaymentMethods } from "../../redux/slice/paymentMethod/paymentMethodSlice";
import { useSelector, useDispatch } from "react-redux";
import ScrollGames from "../ScrollGames/ScrollGames";
// import OpenBets from "../OpenBets/OpenBets";
import OpenBets from "../OpenBets/OpenBets";


const AddWithdrawMethod = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [eventType, setEventType] = useState(undefined);

  const userInfo = Helper();
  const userInfos = useSelector((state) => state.paymentMethods); // Use selector to access state
  const paymentMethod = userInfos?.paymentMethods || [];
  console.log("paymentMethod", paymentMethod);

  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  let balanceWithExp = balance - Math.abs(exposure);

  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("new-account"); // Set default to 'new-account'
  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [buttonText, setButtonText] = useState("Submit"); // State for button text
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [showAddAccountForm, setAddAccountForm] = useState(false);
  const [showBankForm, setShowBankForm] = useState("");
  const [showUpiForm, setShowUpiForm] = useState("");
  const [showEditPopup, setShowEditPopup] = useState(false); // State to handle Edit form popup visibility
  const [editingSection, setEditingSection] = useState(null); // Track which section is being edited
  const [showPreviousAccount, setShowPreviousAccount] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [bankName, setBankName] = useState("");
  const [showWithdrawHistory, setShowWithdrawHistory] = useState(true);

  const [upiId, setUpiId] = useState("");
  const [upiHolder, setUpiHolder] = useState("");
  const [button, setButton] = useState(false);

  const [AcNumValidationError, setAcNumValidationError] = useState(
    "Please enter account number"
  );
  const [AcHolderValidationError, setAcHolderValidationError] = useState(
    "Please enter account holder name"
  );
  const [IfscValidationError, setIfscValidationError] = useState(
    "Please enter ifsc code"
  );
  const [BankValidationError, setBankValidationError] = useState(
    "Please enter bank name"
  );
  const [UPIValidationError, setUPIValidationError] =
    useState("Please enter id");
  const [HolderValidationError, setHolderValidationError] = useState(
    "Please enter holder name"
  );

  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);

  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    name: "Example",
    accountNumber: "12345678xxxx",
    ifscCode: "SBIN000002",
    bankName: "State Bank of India",
  });

  const [UPIDetails, setUPIDetails] = useState({
    upi_id: "1234fgd",
    phoneNumber: "12345678xxxx",
  });

  // Handle changes in the Bank input fields during editing
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({
      ...bankDetails,
      [name]: value,
    });
  };

  useEffect(() => {
    getUserPaymentMethods();
  }, []);

  const getUserPaymentMethods = () => {
    dispatch(
      getPaymentMethods({
        site_code: Appconfig.sitecodes,
        user_id: userInfo?._id,
      })
    );
  };

  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo]);

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance);
          setExposure(response.data.resultData?.exposure);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Handle changes in the UPI input fields during editing
  const handleUPIInputChange = (e) => {
    const { name, value } = e.target;
    setUPIDetails({
      ...UPIDetails,
      [name]: value,
    });
  };

  const toggleEditPopup = (section) => {
    setEditingSection(section); // Set the section (either "bank" or "upi")
    setShowEditPopup(!showEditPopup); // Toggle the popup
  };

  function deletePaymentDetails(id) {
    var data = JSON.stringify({
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}paymentMethod/deleteType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getUserPaymentMethods();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handlePreviousAccount = () => {
    setShowPreviousAccount(!showPreviousAccount);
    setShowPaymentMethods(false);
  };

  // Function to handle button click
  const handleButtonClick = (value) => {
    setInputValue(value);
  };

  // Function to handle payment option click
  const handleClick = (option) => {
    setSelectedOption(selectedOption === option ? null : option); // Toggle between opening/closing
  };

  const handlePaymentMethod = () => {
    setShowPaymentMethods(!showPaymentMethods);
    setShowPreviousAccount(false);

    // Hide all forms using an array of form setters
    [setShowUpiForm].forEach((setter) => setter(false));
  };

  const handleFormToggle = (form) => {
    setUpiId("");
    setUpiHolder("");
    setShowUpiForm(form);
  };

  // Button values
  const buttonValues = [500, 1000, 1500, 2000, 2500, 3000];

  const tickMark = (
    <svg
      width="58"
      height="45"
      viewBox="0 0 58 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M19.11 44.64L.27 25.81l5.66-5.66 13.18 13.18L52.07.38l5.65 5.65"
      />
    </svg>
  );

  function checkValidation() {
    if (showUpiForm == "Bank") {
      if (!accountNumber) {
        setAcNumValidationError("Please enter account number");
        document.querySelector(".acnum").classList.remove("hidden");
      }
      if (!accountHolder) {
        setAcHolderValidationError("Please enter holder name");
        document.querySelector(".acholder").classList.remove("hidden");
      }
      if (!ifscCode) {
        setIfscValidationError("Please enter ifsc code");
        document.querySelector(".ifsccode").classList.remove("hidden");
      }

      if (!bankName) {
        setBankValidationError("Please enter bank name");
        document.querySelector(".bankname").classList.remove("hidden");
      }

      if (accountNumber && accountHolder && ifscCode && bankName) {
        return true;
      }
      return false;
    } else {
      if (!upiId) {
        setUPIValidationError("Please enter upi id");
        document.querySelector(".upiid").classList.remove("hidden");
      }
      if (!upiHolder) {
        setHolderValidationError("Please enter holder name");
        document.querySelector(".holder").classList.remove("hidden");
      }
      if (upiId && upiHolder) {
        return true;
      }
      return false;
    }
  }

  // Handle submit click and toggle button text & style
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    console.log();

    if (userInfo && showUpiForm) {
      if (checkValidation()) {
        const formData = new FormData();

        formData.append("master_id", userInfo?.master_id);
        formData.append("user_id", userInfo?._id);
        formData.append("site_code", userInfo?.site_code);
        formData.append("type", showUpiForm);
        formData.append("bank_name", bankName);
        formData.append("account_no", accountNumber);
        formData.append("account_holder_name", accountHolder);
        formData.append("ifsc_code", ifscCode);
        formData.append("holder_name", upiHolder);
        formData.append("upi_id", upiId);

        var config = {
          method: "post",
          url: `${Appconfig.apiUrl}withdraw/addWithdrawPaymentMethod`,
          headers: {
            "Content-Type": "application/json",
          },
          data: formData,
        };
        axios(config)
          .then(function (response) {
            if (response.data.result) {
              setButtonText("Thanks");
              setIsSubmitted(true);
              toast.success(response.data.resultMessage, { autoClose: 2000 });

              setTimeout(() => {
                navigate("/withdraw");
              }, 2000);
            } else {
              toast.error(response.data.resultMessage, { autoClose: 2000 });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    } else {
      toast.error("Please select payment method or fill all the fields!", {
        autoClose: 2000,
      });
    }
  };

  function cancelWithdrawRequest(record, status) {
    setButton(true);
    var data = JSON.stringify({
      record: record,
      status: status,
      master_details: userInfo,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/confirmWithdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getWithdrawHistory();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setButton(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const methodColumns = [
    {
      title: "Type",
      sorter: true,
      render: (_, record) => <span className="">{record?.type}</span>,
    },
    {
      title: "Holder Name",
      sorter: true,
      render: (_, record) => (
        <span className="">
          {record?.type == "Bank" ? record?.accountHolder : record?.holderName}
        </span>
      ),
    },
    {
      title: "UPI ID",
      sorter: true,
      render: (_, record) => <span className="">{record?.upiId}</span>,
    },
    {
      title: "Account No.",
      sorter: true,
      render: (_, record) => <span className="">{record?.accountNo}</span>,
    },
    {
      title: "UPI ID",
      sorter: true,
      render: (_, record) => <span className="">{record?.upiId}</span>,
    },
    {
      title: "IFSC Code",
      sorter: true,
      render: (_, record) => <span className="">{record?.ifscCode}</span>,
    },
    {
      title: "Bank Name",
      sorter: true,
      render: (_, record) => <span className="">{record?.bankName}</span>,
    },
    {
      title: "More",
      sorter: true,
      render: (_, record) => (
        <div className="">
          <button
            disabled={button}
            onClick={() => deleteWithdrawMethod(record?._id)}
            className="custom-button"
          >
            <span>Delete</span>
          </button>
          <button
            disabled={button}
            onClick={() =>
              statusWithdrawMethod(
                record?._id,
                record?.status == "Active" ? "Inactive" : "Active"
              )
            }
            className="custom-button"
            style={{ color: record?.status == "Active" ? "green" : "red" }}
          >
            <span>{record?.status}</span>
          </button>
        </div>
      ),
    },
  ];

  const getWithdrawHistory = () => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/getWithdrawHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setWithdrawHistory(response.data.resultData);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const deleteWithdrawMethod = (id) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/deleteWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            })
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const statusWithdrawMethod = (id, status) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
      status: status,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/statusWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            })
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function selectPaymentDetail(detail) {
    setBankName(detail?.bankName);
    setAccountNumber(detail?.accountNo);
    setAccountHolder(detail?.accountHolder);
    setIfscCode(detail?.ifscCode);
    setUpiId(detail?.upiId);
    setUpiHolder(detail?.holderName);
    setShowUpiForm(detail?.type);
  }

  useEffect(() => {
    getWithdrawHistory();
    handlePaymentMethod();
  }, []);

  // useEffect(() => {
  //   document.body.style.overflow = selectedOption === "new-account" ? "hidden" : "auto";
  // }, [selectedOption]);

  const handlePaymentMethodSelect = (method) => {
    setShowUpiForm(method); // e.g. "UPI", "Bank", etc.
    setSelectedOption("new-account"); // or whatever logic you use
    setShowFormModal(true); // <-- open modal
  };

  useEffect(() => {
    document.body.style.overflow = showFormModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showFormModal]);

  return (
    <>
      {/* <ScrollGames eventType={eventType} setEventType={setEventType} /> */}

      <div className="w-full lg:pl-[295px]"> {/* Wrapper to respect the external left sidebar on large screens */}
        {/* This is the main layout container.
    - flex-col: Stacks content vertically on mobile.
    - lg:flex-row: Switches to a horizontal layout on large screens.
    - gap-6: Adds space between the main content and the sidebar.
    - p-4: Provides padding around the content area.
  */}
        <div className="flex w-full flex-col lg:flex-row gap-6 p-4">

          {/* ===================== */}
          {/* == Main Content Column == */}
          {/* ===================== */}
          <div className="w-full lg:flex-grow flex flex-col gap-6">

            {/* --- Breadcrumb Navigation --- */}
            <div className="w-full">
              <nav className="flex items-center space-x-1 text-sm" aria-label="Breadcrumb">
                <a title="LotusPlus365-Home" className="flex items-center text-gray-600 hover:text-blue-600" href="/">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 576 512" fill="currentColor">
                    <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path>
                  </svg>
                </a>
                <div className="flex items-center">
                  <svg className="h-5 w-5 flex-shrink-0 text-gray-400" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 6l6 6l-6 6"></path>
                  </svg>
                  <a className="ml-1 text-lg font-semibold text-gray-800 hover:underline" aria-current="page" title="Back" href="/withdraw">
                    Back
                  </a>
                </div>
              </nav>
            </div>

            {/* --- Main Content Card --- */}
            <div className="bg-white rounded-xl shadow-xl p-4 sm:p-6 flex flex-col gap-8">
              {/* Section: Select Payment Method */}
              <div>
                <h3 className="text-lg font-semibold mb-4 text-gray-800">Select Payment Method</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                  {Appconfig.withdraw_account_type?.map((type) => (
                    <button
                      key={type}
                      onClick={() => handlePaymentMethodSelect(type)}
                      className={`flex flex-col items-center justify-center py-3 px-2 border rounded-xl transition duration-200 hover:shadow-lg hover:border-teal-500 ${type === showUpiForm ? "ring-2 ring-teal-500 border-teal-500" : "border-gray-200"}`}
                    >
                      <img
                        src={`../Images/${type === "Bank" ? "bank.jpg" : type === "Gpay" ? "icons8-google-pay.svg" : type === "UPI" ? "icons8-bhim-50.svg" : type === "Phonepe" ? "icons8-phone-pe.svg" : "icons8-paytm.svg"}`}
                        alt={type}
                        className="w-12 h-12 mb-2 object-contain"
                      />
                      <span className="text-sm font-medium text-gray-700">{type}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Section: Add New Method Button */}
              <div className="w-full pt-2">
                <div className="relative overflow-hidden  w-full text-white h-11 text-base shadow-lg rounded-md font-bold leading-4 flex gap-x-1 items-center justify-center cursor-pointer hover:bg-teal-700 transition bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef]">
                  <span>Add New Payment Method</span>
                </div>
              </div>
            </div>

            {/* --- Modal for Form --- */}
            {/* This modal structure is already responsive */}
            {(showUpiForm || selectedOption === "previous-account") && showFormModal && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4"
                onClick={() => setShowFormModal(false)}
              >
                <div
                  className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative overflow-y-auto max-h-[90vh]"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onClick={() => setShowFormModal(false)}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-800 text-2xl"
                  >
                    &times;
                  </button>

                  <form onSubmit={handleSubmitClick} className="space-y-4 pt-6">
                    {/* Bank Form */}
                    {showUpiForm === "Bank" && (
                      <>
                        <div>
                          <input type="text" value={ifscCode} onChange={(e) => setIfscCode(e.target.value)} placeholder="Enter IFSC Code" className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{IfscValidationError}</span>
                        </div>
                        <div>
                          <input type="number" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} placeholder="Enter Account Number" className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{AcNumValidationError}</span>
                        </div>
                        <div>
                          <input type="text" value={bankName} onChange={(e) => setBankName(e.target.value)} placeholder="Enter Bank Name" className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{BankValidationError}</span>
                        </div>
                        <div>
                          <input type="text" value={accountHolder} onChange={(e) => setAccountHolder(e.target.value)} placeholder="Enter Account Holder Name" className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{AcHolderValidationError}</span>
                        </div>
                      </>
                    )}

                    {/* UPI Form */}
                    {(showUpiForm === "UPI" || showUpiForm === "Phonepe" || showUpiForm === "Gpay" || showUpiForm === "Paytm") && (
                      <>
                        <div>
                          <input type="text" value={upiId} onChange={(e) => setUpiId(e.target.value)} placeholder={`Enter ${showUpiForm} ID`} className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{UPIValidationError}</span>
                        </div>
                        <div>
                          <input type="text" value={upiHolder} onChange={(e) => setUpiHolder(e.target.value)} placeholder={`Enter ${showUpiForm} Holder Name`} className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500" />
                          <span className="text-red-500 text-xs mt-1">{HolderValidationError}</span>
                        </div>
                      </>
                    )}

                    <label className="flex items-center space-x-3 text-sm text-gray-600">
                      <input type="checkbox" className="h-4 w-4 rounded accent-teal-600" checked={isTermsChecked} onChange={(e) => setIsTermsChecked(e.target.checked)} />
                      <span> I have read the <a href="#" className="underline text-teal-600">terms of payment</a>.</span>
                    </label>

                    <button
                      type="submit"
                      disabled={isSubmitted}
                      className={`w-full py-3 rounded-lg font-semibold text-white transition duration-200 ${isSubmitted ? "bg-green-500 cursor-not-allowed" : "bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400"}`}
                    >
                      {buttonText}
                    </button>
                  </form>
                </div>
              </div>
            )}

            {/* --- History/Methods Section --- */}
            <div className="w-full mt-4 flex flex-col items-center">
              <button
                onClick={() => setShowWithdrawHistory(!showWithdrawHistory)}
                className="px-5 py-2  bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef] text-white rounded-lg font-semibold hover:bg-teal-700 transition duration-200"
              >
                {showWithdrawHistory ? "Hide Withdraw Methods" : "Show Withdraw Methods"}
              </button>

              {showWithdrawHistory && (
                <div className="w-full mt-6 bg-white p-4 rounded-xl shadow-lg">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Withdraw Methods</h3>
                  {/* The overflow-x-auto wrapper makes the table horizontally scrollable on small screens */}
                  <div className="overflow-x-auto">
                    <Table
                      columns={methodColumns}
                      dataSource={paymentMethod}
                      bordered
                      pagination={true}
                    />
                  </div>
                </div>
              )}
            </div>

          </div>

        </div>
      </div>
    </>
  );
};

export default AddWithdrawMethod;
